import { isGuestAgreed, setGuestAgreed } from '@/utils/guestSession';

export const nonpersist = {
  namespaced: true,
  state: {
    user: {},
    prefetched: false,
    asrTimeLeft: 0,
    // Согласие гостя живёт в sessionStorage вкладки, чтобы не спрашивать его повторно,
    // когда мобильный браузер выгрузил и перезагрузил страницу.
    guestAgreed: isGuestAgreed(),
    sessionPassword: "",
    showGuide: false,
  },
  actions: {
    
  },
  getters: {
    getUserOrganization(state) {
      return state.user?.organization
    },
  },
  mutations: {
    setUser(state, user) {
      state.user = user;
    },
    setUserLanguage(state, language) {
      state.user.language = language;
    },
    setPrefetched(state, bool) {
        state.prefetched = bool;
    },
    setAsrTimeLeft(state, asrTimeLeft) {
      state.asrTimeLeft = asrTimeLeft;
    },
    setGuestAgreed(state, bool) {
      state.guestAgreed = bool;
      setGuestAgreed(bool);
    },
    setSessionPassword(state, pwd) {
      state.sessionPassword = pwd;
    },
    setShowGuide(state, bool) {
      state.showGuide = bool;
    },
  }
}